import { isEqual, isString } from '@antv/util';
import { CommonEvent } from '../constants';
const lowerCaseKeys = (keys) => keys.map((key) => (isString(key) ? key.toLocaleLowerCase() : key));
export class Shortcut {
    map = new Map();
    emitter;
    recordKey = new Set();
    constructor(emitter) {
        this.emitter = emitter;
        this.bindEvents();
    }
    bind(key, handler) {
        if (key.length === 0)
            return;
        this.map.set(key, handler);
    }
    unbind(key, handler) {
        this.map.forEach((h, k) => {
            if (isEqual(k, key)) {
                if (!handler || handler === h)
                    this.map.delete(k);
            }
        });
    }
    unbindAll() {
        this.map.clear();
    }
    match(key) {
        // 排序
        const recordKeyList = lowerCaseKeys(Array.from(this.recordKey)).sort();
        const keyList = lowerCaseKeys(key).sort();
        return isEqual(recordKeyList, keyList);
    }
    bindEvents() {
        const { emitter } = this;
        emitter.on(CommonEvent.KEY_DOWN, this.onKeyDown);
        emitter.on(CommonEvent.KEY_UP, this.onKeyUp);
        emitter.on(CommonEvent.WHEEL, this.onWheel);
        emitter.on(CommonEvent.DRAG, this.onDrag);
        // 窗口重新获得焦点后清空按键，避免按键状态异常
        // Clear the keys when the window regains focus to avoid abnormal key states
        window.addEventListener('focus', this.onFocus);
    }
    onKeyDown = (event) => {
        if (!event?.key)
            return;
        this.recordKey.add(event.key);
        this.trigger(event);
    };
    onKeyUp = (event) => {
        if (!event?.key)
            return;
        this.recordKey.delete(event.key);
    };
    trigger(event) {
        this.map.forEach((handler, key) => {
            if (this.match(key))
                handler(event);
        });
    }
    /**
     * <zh/> 扩展 wheel, drag 操作
     *
     * <en/> Extend wheel, drag operations
     * @param eventType - event name
     * @param event - event
     */
    triggerExtendKey(eventType, event) {
        this.map.forEach((handler, key) => {
            if (key.includes(eventType)) {
                if (isEqual(Array.from(this.recordKey), key.filter((k) => k !== eventType))) {
                    handler(event);
                }
            }
        });
    }
    onWheel = (event) => {
        this.triggerExtendKey(CommonEvent.WHEEL, event);
    };
    onDrag = (event) => {
        this.triggerExtendKey(CommonEvent.DRAG, event);
    };
    onFocus = () => {
        this.recordKey.clear();
    };
    destroy() {
        this.unbindAll();
        this.emitter.off(CommonEvent.KEY_DOWN, this.onKeyDown);
        this.emitter.off(CommonEvent.KEY_UP, this.onKeyUp);
        this.emitter.off(CommonEvent.WHEEL, this.onWheel);
        this.emitter.off(CommonEvent.DRAG, this.onDrag);
        window.removeEventListener('blur', this.onFocus);
    }
}
//# sourceMappingURL=shortcut.js.map